export const urls = {
  GET_KUPCI: 'Kupci/vrati_kupce',
  INSERT_KUPAC: 'Kupci/unos_kupca',
  UPDATE_KUPAC: 'Kupci/izmena_kupca',
  DELETE_KUPAC: 'Kupci/brisanje_kupca',
  GET_RANATNE_GRUPE: 'Combo/vrati_rabatne_grupe',
};
